import React from 'react'
import { FormattedMessage } from 'react-intl'
import { RESERVE_TYPES } from 'constants'

export const RESERVE_MAIN_BONUS_DESCRIPTION = {
    [RESERVE_TYPES.INSPIRATION]: (
        <FormattedMessage
            id='reserves_toolbar.main_bonus_description.crew_roles_factor'
            defaultMessage='к{nbsp}специальности экипажа'
            values={{
                nbsp: <span>&nbsp;</span>,
            }}
        />
    ),
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='reserves_toolbar.main_bonus_description.artillery_strike'
            defaultMessage='максимальный урон (ед.)'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/Stronghold/components/ReserveButton/translations.jsx